import React from "react"
import { Field } from "redux-form/immutable"
import { InputField } from "app/static/frontend/forms/components/InputField"

export const EmailField = (props) => {
    return <Field {...props} component={InputField} />
}
